import AdministrativeAgentEdit from './AdministrativeAgentEdit';

export default AdministrativeAgentEdit;
